import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';


@Injectable()
export class XmlFileEditorService {
  readonly rootUrl = AppSettings.webApiURL;
  
  constructor(public httpClient: HttpClient) { }


  public getOriginalFileData(fileId: string) {
    return this.httpClient.get(`${this.rootUrl}/api/XmlFileEditor/getOriginalFileData?fileId=${fileId}`);
  }

  public saveFileData(data: any, CustomerId: string, msvEditFileName: string) {
    //let data: string = JSON.stringify(dataJson);
    const headers = new HttpHeaders().set('content-type', 'application/json');
    //?CustomerId=${CustomerId}&msvEditFileName=${msvEditFileName}
    return this.httpClient.post(`${this.rootUrl}/api/XmlFileEditor/saveXmlFileData?CustomerId=${CustomerId}&msvEditFileName=${msvEditFileName}`, data, { headers });
  }
  

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/xml-file-editor.service.ts